import axios from 'axios';

// Device-stored session key: survives PWA restarts even when the browser drops the cookie.
const TOKEN_KEY = 'lumera_token';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);
export const setAuthToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearAuthToken = () => localStorage.removeItem(TOKEN_KEY);

const isApiUrl = (url) => typeof url === 'string' && (url.startsWith(`${BACKEND_URL}/api`) || url.startsWith('/api'));

axios.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t && isApiUrl(config.url) && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

if (typeof window !== 'undefined' && window.fetch && !window.fetch.__lumeraAuth) {
  const origFetch = window.fetch.bind(window);
  const wrapped = (input, init = {}) => {
    const t = getAuthToken();
    const url = typeof input === 'string' ? input : input?.url;
    if (!t || !isApiUrl(url)) return origFetch(input, init);
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${t}`);
    return origFetch(input, { ...init, headers });
  };
  wrapped.__lumeraAuth = true;
  window.fetch = wrapped;
}
